<!-- <div id="controls"></div> -->

<div class="mt-3 route-controls p-2 shadow-sm mb-3">
  <div class="head mb-3 d-flex align-items-center">
    <img src="assets/mmda.svg" alt="">
    <div class="text ml-10">
      <p class="t-fs12 m-0">Metropolitan Manila Development Authority</p>
      <p class="t-fs20 t-fw700 m-0">MMDA TRAFFIC CONTROL</p>
      <p class="t-fs14 t-fw500 m-0">Command Center</p>
    </div>
  </div>

  <div class="main-container">
    <ng-container *ngIf="!activeRoute">
      <div *ngFor="let route of routes" 
        class="route d-flex align-items-center justify-content-between pointer" 
        (click)="focusRoute(route?.id)"
        [class.route-active]="activeRoute == route?.id">
        <div class="text-icon d-flex align-items-center">
          <!-- <img [src]="'assets/icons/'+route?.id+'.svg'" alt=""> -->
          <div class="route-container ml-10"> 
            <label class="form-check-label">
              <span class="fw-bold">{{ route.label }}</span>
            </label>
          </div>
        </div>
        <button class="btn btn-sm">
          <!-- <i class="fa-solid fa-magnifying-glass"></i> -->
          <img src="assets/chevron-forward.svg" alt="">
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="activeStops?.length > 0">
      <div class="route-details">
        <div class="row mb-3">
          <div class="col-md-2 d-flex justify-content-center align-items-center">
            <div class="back-container d-flex justify-content-center align-items-center pointer" (click)="resetActiveRouteStops()">
              <img src="assets/chevron-back.svg" alt="">
            </div>
          </div>
          <div class="col-md-10">
            <p class="m-0">
              <span class="t-fs12">From: </span>
              <span class="t-fs18 t-fw700">{{firstLastStops?.firstStop?.name}}</span>
            </p>
            <p class="m-0">
              <span class="t-fs12">To: </span>
              <span class="t-fs18 t-fw700">{{firstLastStops?.lastStop?.name}}</span>
            </p>
          </div>
        </div>
      </div>
      <div *ngFor="let stop of activeStops; let first=first" 
        class="stops"
        (click)="focusStop(stop)"
        [class.first-stop]="first">
        <div class="row pointer">

          <div class="line"></div>
          <div class="col-md-2 d-flex justify-content-center p-0"
            [class.align-items-center]="!first">
            <img src="assets/icons/pin-start.svg" alt="" *ngIf="first">
            <div class="point" *ngIf="!first"></div>
          </div>
          <div class="col-md-10 d-flex justify-content-between align-items-center">
            <div class="text-icon d-flex align-items-center">
            <div class="stops-container ml-10"> 
              <label class="form-check-label pointer">
                <span class="fw-bold">{{ stop.name }}</span>
              </label>
            </div>
          </div>
          <button class="btn btn-sm">
            <img src="assets/chevron-forward.svg" alt="" *ngIf="stop?.name !== currentStop?.name">
            <div class="circle" *ngIf="stop?.name == currentStop?.name"></div>
          </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>  
</div>

<div id="map" style="height: 100vh; width: 100%;"></div>

<div id="stop-modal" class="stop-modal" *ngIf="activeStop">
  <div class="stop-modal-container">
    <h5>{{ activeStop.name }}</h5>
    <p>{{ activeStop.lat.toFixed(4) }}, {{ activeStop.lng.toFixed(4) }}</p>
  </div>
  
</div>